import { getGameSpecificDevice } from '@/features/game/platform-helpers';
import { FGPIgtLaunchData } from '@/features/providers/igt/types';
import { buildUrl } from '@/utils/build-url';

const igtUrlBuilderFgp = (data: FGPIgtLaunchData): string => {
  const {
    countryCode,
    currencycode,
    host,
    language,
    nscode,
    presenttype,
    securetoken,
    skincode,
    softwareid,
    technology,
    uniqueid,
    url,
  } = data.launchDetails;

  if (url) {
    return url;
  }

  const gameChannel = getGameSpecificDevice();

  const deviceMapper = {
    DESKTOP: 'INT',
    PHONE: 'MOB',
    TABLE: 'TAB',
    UNKNOWN: 'INT',
  };

  const channel = deviceMapper[gameChannel];

  const params = {
    uniqueid,
    currencycode,
    countrycode: countryCode,
    softwareid,
    nscode,
    skincode,
    securetoken,
    presenttype,
    language,
    technology,
    channel,
  };

  return buildUrl(`https://${host}/skb/gateway`, params);
};

export const buildIgtUrl = (input: FGPIgtLaunchData): string =>
  igtUrlBuilderFgp(input);
